export const FORM_SUBTITLE_ID = 'FormSubtitle';
export const FORM_ELEMENT_ID = 'FormElement';
export const FORM_HELPER_TEXT_ID = 'FormHelperText';
export const FORM_COUNTER_ID = 'FormCounter';
export const FORM_HEADER_ID = 'FormHeader';
export const FORM_LABEL_ID = 'FormLabel';
export const FORM_OPTIONAL_LABEL_ID = 'FormOptionalLabel';
export const FORM_TOOLTIP_ID = 'FormTooltip';

export const FORM_FOOTER_LINE_HEIGHT = 'b_sm';
